<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="待开票" name="wait-apply"></el-tab-pane>
      <el-tab-pane label="已开票" name="applied-list"></el-tab-pane>
      <el-tab-pane label="已废弃" name="abandon-list"></el-tab-pane>
    </el-tabs>
    <component :is="activeTab"></component>
  </div>
</template>

<script>
import WaitApply from './wait-apply'
import AppliedList from './applied-list'
import AbandonList from './abandon-list'

export default {
  name: 'invoice-list',
  components: {
    WaitApply,
    AppliedList,
    AbandonList
  },
  props: {
    tab: {
      type: String,
      default: 'wait-apply'
    }
  },
  mounted() {
    if (this.tab) {
      this.activeTab = this.tab
    }
  },
  data() {
    return {
      activeTab: 'wait-apply'
    }
  },
  methods: {
    handleTabChange(val) {
      this.$router.replace({ path: '/invoice/invoice-list', query: { tab: val.name } })
    }
  }
}
</script>

<style lang="scss" scoped></style>
